import { ArrowForwardIos } from "@mui/icons-material";
import {
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  AccordionDetailsProps,
  AccordionProps,
  AccordionSummary as MuiAccordionSummary,
  AccordionSummaryProps,
  styled,
} from "@mui/material";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} {...props} />
))(() => ({
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

export const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIos sx={{ transform: "rotate(90deg)", width: 16 }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: theme.palette.common.dimmedPageBackground,
  borderRadius: "6px",
  minHeight: 40,
}));

export const AccordionDetails = styled((props: AccordionDetailsProps) => (
  <MuiAccordionDetails {...props} />
))(() => ({
  alignItems: "flex-start",
  display: "flex",
  flexDirection: "column",
  gap: 16,
  padding: 16,
}));

export default Accordion;
